// These will be replaced on build
export const buildVersion = '__buildVersion__'
export const buildEnv = '__buildEnv__'
export const buildDate = '__buildDate__'
